import React, { useState, useEffect } from "react";
import axiosInstance from "../common/axios";
import { TextField, Button, Grid, MenuItem, Typography, FormControl, InputLabel, Select } from "@mui/material";
import { useAuth } from '../context/AuthContext';
import {saveProduct} from '../service/productService';
import FormInstructionBox from '../components/FormInstructionBox';

const AddProduct = (supplierData) => {
  
    const { userSupplier , user } = useAuth();
  
  const [product, setProduct] = useState({
    productName: "",
    description: "",
    imageUrl: "",
    basePrice: "",
    discountPercent: "",
    maxPrice: "",
    maxOrderQuantityPerUser: "",
    salesPrice: "",
    availableCountry: "",
    availableState: "",
    availableCity: "",
    currencyId: "",
    supplierId: "",
    sku: "",
    subCategoryId: "",
    tagIds: [],
    brandId: "",
    sharedDiscount: {
      discountId: ""
    },
    couponDiscount: {
      couponId: ""
    }
  });

  const [variants, setVariants] = useState([
    {
      variantName: "",
      sku: "",
      color: "",
      size: "",
      imageUrl: "",
      price: "",
      stockQuantity: "",
      isActive: false,
      currencyId: "",
      taxPercent: "",
       sgstPercent: "",
        cgstPercent: "",
        discount: {
          discountId: ""
        }
    }
  ]);
 
  // Dropdown data 
  const [currencies, setCurrencies] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [discounts, setDiscounts] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [brands, setBrands] = useState([]);
  const [tags, setTags] = useState([]);
  
        const addproductsInstructions = [
        "Atleast one Variant is required. ",
        "Fill in all the required fields.",
        " if the field is not required and you dont have to enter the details if it is not appropriate.",
        "If you have not sent the Images to the Adminstrator. Enter no_image.png for Image field.",
        "If you have any questions or need more help. Please contact the System Administrator.WhatsApp or Phone: +91 999 464 1128",
        "Click 'Edit and Update' to apply changes, or 'Cancel' to discard."
    ];

  useEffect(() => {
    // Fetch dropdown data
    axiosInstance.get("/api/currencies").then((res) => setCurrencies(res.data.content));

    axiosInstance.get("/api/subcategories").then((res) => setSubCategories(res.data));
    axiosInstance.get("/api/brands").then((res) => setBrands(res.data));
    if(user){
    axiosInstance.get("/api/coupons").then((res) => setCoupons(res.data));
    axiosInstance.get("/api/discounts").then((res) => setDiscounts(res.data));
       axiosInstance.get("/api/suppliers").then((res) => setSuppliers(res.data));
    }else{
      setSuppliers([supplierData.data]);
    }
 
    //  axiosInstance.get('/api/tags').then(res => setTags(res.data));
  }, []);

  const handleProductChange = (e) => {
    const { name, value } = e.target;

    if (name === "couponId") {
      setProduct((prev) => ({
        ...prev,
        couponDiscount: {
          ...prev.couponDiscount,
          [name]: value
        }
      }));
    } else if (name === "discountId") {
      setProduct((prev) => ({
        ...prev,
        sharedDiscount: {
          ...prev.sharedDiscount,
          [name]: value
        }
      }));
    } else {
      setProduct((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleTagsChange = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map((opt) => Number(opt.value));
    setProduct((prev) => ({ ...prev, tagIds: selectedOptions }));
  };

  const handleVariantChange = (index, e) => {
  const { name, value } = e.target;
  const updatedVariants = [...variants];

  // This condition checks if the changed input is related to a discount
  if (name === "discountId") {
    // Correctly update the nested discount object
    updatedVariants[index].discount.discountId = value;

  } else {
    // For all other inputs, update the variant directly
    updatedVariants[index][name] = value;
  }

  // Set the state with the new array
  setVariants(updatedVariants);
};
/*  const handleVariantChange = (index, e) => {
    const updatedVariants = [...variants];
    
     const { name, value } =  updatedVariants[index][e.target];
    if (name === "discountId") {
      
       setVariants((prev) => ({
        ...prev,
        discount: {
          ...prev.discount,
          [name]: value
        }
      }));
    }
    updatedVariants[index][e.target.name] = e.target.value;
    setVariants(updatedVariants);
  };*/

  const addVariant = () => {
    setVariants([
      ...variants,
      {
        variantName: "",
        sku: "",
        color: "",
        size: "",
        imageUrl: "",
        price: "",
        stockQuantity: "",
        isActive: false,
        currencyId: "",
        taxPercent: "",
         sgstPercent: "",
        cgstPercent: "",
        discount: {
          discountId: ""
        }
      }
    ]);
  };

  const removeVariant = (index) => {

    if(variants.length <= 1){
      alert("The Variant cannot be Removed. Atleast One Variant is Required! ");
      return;
    }
    
    const updated = [...variants];
    updated.splice(index, 1);
    setVariants(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    
    try {
      
      saveProduct( { ...product, variants });
      
     // axiosInstance.post("/api/products", { ...product, variants });
      alert("Product created successfully");
      
      setProduct({
    productName: "",
    description: "",
    imageUrl: "",
    basePrice: "",
    discountPercent: "",
    maxPrice: "",
    maxOrderQuantityPerUser: "",
    salesPrice: "",
    availableCountry: "",
    availableState: "",
    availableCity: "",
    currencyId: "",
    supplierId: "",
    sku: "",
    subCategoryId: "",
    tagIds: [],
    brandId: "",
    sharedDiscount: {
      discountId: ""
    },
    couponDiscount: {
      couponId: ""
    }
  });
 setVariants([
      {
        variantName: "",
        sku: "",
        color: "",
        size: "",
        imageUrl: "",
        price: "",
        stockQuantity: "",
        isActive: false,
        isApproved: false,
        currencyId: "",
        taxPercent: "",
        sgstPercent: "",
        cgstPercent: "",
        discount: {
          discountId: ""
        }
      }
    ]);

      
    } catch (err) {
      console.error(err);
      alert("Error creating product");
    }
  };

  return (
    <form id="productForm" onSubmit={handleSubmit}>
      <h2>Add Product</h2>


       <FormInstructionBox 
                instructions={addproductsInstructions} 
                title="Add Products Guidelines" 
            />
      <Grid container spacing={2}>
        <Grid item x={12} md={6}>
          <TextField
            name="productName"
            value={product.productName}
            onChange={handleProductChange}
            label="Product Name"
            fullWidth
            required
          />
        </Grid>{" "}
        <Grid item x={12} md={6}>
          <TextField
            name="description"
            value={product.description}
            onChange={handleProductChange}
            label="Description"
            fullWidth
            required
          />
        </Grid>{" "}
        <Grid item x={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="brand-label">Brand</InputLabel>
            <Select
              labelId="brand-label"
              required
              id="brandId"
              name="brandId"
              value={product.brandId || ""}
              onChange={handleProductChange}
              label="Brand">
              <MenuItem value="">
                <em>Select Brand</em>
              </MenuItem>
              {brands.map((c) => (
                <MenuItem key={c.brandId} value={c.brandId}>
                  {c.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>{" "}
        <Grid item x={12} md={6}>
          <TextField
            name="imageUrl"
            value={product.imageUrl}
            onChange={handleProductChange}
            label="Image URL"
            fullWidth
          />
        </Grid>{" "}
        <Grid item xs={12} md={6}>
          <TextField
            name="basePrice"
            type="number"
            value={product.basePrice}
            onChange={handleProductChange}
            label="Base Price"
            fullWidth
            required
          />
        </Grid>{" "}
   <Grid item xs={12} md={6}>
          <TextField
            name="maxPrice"
            type="number"
            value={product.maxPrice}
            onChange={handleProductChange}
            label="Max Price"
            fullWidth
            required
          />
        </Grid>{" "}
{user && user.roles[0].role === "ROLE_ADMIN" && 
<>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="discount-label">Discount</InputLabel>
            <Select
              labelId="discount-label"
              id="discountId"
              name="discountId"
              value={product.sharedDiscount?.discountId || ""}
              onChange={handleProductChange}
              label="Discount">
              <MenuItem value="">
                <em>Select Discount</em>
              </MenuItem>
              {discounts.map((c) => (
                <MenuItem key={c.discountId} value={c.discountId}>
                  {c.percentage} - {c.amount}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="coupon-label">Coupon</InputLabel>
            <Select
              labelId="coupon-label"
              id="couponId"
              name="couponId"
              value={product.couponDiscount?.couponId || ""}
              onChange={handleProductChange}
              label="Coupon">
              <MenuItem value="">
                <em>Select Coupon</em>
              </MenuItem>
              {coupons &&
                coupons.map((c) => (
                  <MenuItem key={c.couponId} value={c.couponId}>
                    {c.code} - {c.discountType} - {c.discountValue}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
</>
}
        <Grid item xs={12} md={6}>
          <TextField
            name="maxOrderQuantityPerUser"
            type="number"
            value={product.maxOrderQuantityPerUser}
            onChange={handleProductChange}
            label="Max Order Per User"
            fullWidth
            required
          />
        </Grid>{" "}
     {/*  <Grid item xs={12} md={6}>
          <TextField
            name="salesPrice"
            type="number"
            value={product.salesPrice}
            onChange={handleProductChange}
            label="Sales Price"
            fullWidth
          />
        </Grid>{" "} */} 
        <Grid item xs={12} md={6}>
          <TextField
            name="availableCountry"
            value={product.availableCountry}
            onChange={handleProductChange}
            label="Country"
            fullWidth
            required
          />
        </Grid>{" "}
        <Grid item xs={12} md={6}>
          <TextField
            name="availableState"
            value={product.availableState}
            onChange={handleProductChange}
            label="State"
            fullWidth
            required
          />
        </Grid>{" "}
        <Grid item xs={12} md={6}>
          <TextField
            name="availableCity"
            value={product.availableCity}
            onChange={handleProductChange}
            label="City"
            fullWidth
            required
          />
        </Grid>{" "}
        <Grid item xs={12} md={6}>
          <TextField name="sku" value={product.sku} onChange={handleProductChange} label="HSN/SKU Code" fullWidth required />
        </Grid>{" "}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="currency-label">Currency</InputLabel>
            <Select
              labelId="currency-label"
              id="currencyId"
              name="currencyId"
              value={product.currencyId || ""}
              onChange={handleProductChange}
              required
              label="Currency">
              <MenuItem value="">
                <em>Select Currency</em>
              </MenuItem>
              {currencies &&
                currencies.map((c) => (
                  <MenuItem key={c.currencyId} value={c.currencyId}>
                    {c.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>{" "}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="supplierId-label">Supplier</InputLabel>
            <Select
              labelId="supplierId-label"
              id="supplierId"
              name="supplierId"
              value={product.supplierId || ""}
              onChange={handleProductChange}
              required
              label="Supplier">
              <MenuItem value="">
                <em>Select Supplier</em>
              </MenuItem>
              {suppliers &&
                suppliers.map((c) => (
                  <MenuItem key={c.supplierId} value={c.supplierId}>
                    {c.supplierName}
                  </MenuItem>
                ))} 
            </Select>
          </FormControl>
        </Grid>{" "} 
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="subCategoryId-label">SubCategory</InputLabel>
            <Select
              labelId="subCategoryId-label"
              id="subCategoryId"
              name="subCategoryId"
              value={product.subCategoryId || ""}
              onChange={handleProductChange}
              required
              label="SubCategory">
              <MenuItem value="">
                <em>Select SubCategory</em>
              </MenuItem>
              {subCategories &&
                subCategories.map((c) => (
                  <MenuItem key={c.subCategoryId} value={c.subCategoryId}>
                    {c.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        {/*<Grid item xs={12}  md={6}>
     Tag multi-select 
      <select multiple value={product.tagIds} onChange={handleTagsChange}>
        {tags.map(tag => (
          <option key={tag.id} value={tag.id}>{tag.name}</option>
        ))}
      </select>
  </Grid> */}
      </Grid>

      <h3>Variants</h3>
      {variants &&
        variants.map((v, idx) => (
          <div key={idx}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  name="variantName"
                  value={v.variantName}
                  onChange={(e) => handleVariantChange(idx, e)}
                  label="Variant Name"
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  name="sku"
                  value={v.sku}
                  onChange={(e) => handleVariantChange(idx, e)}
                  label="HSN/SKU Code"
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  name="color"
                  value={v.color}
                  onChange={(e) => handleVariantChange(idx, e)}
                  label="Color"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  name="size"
                  value={v.size}
                  onChange={(e) => handleVariantChange(idx, e)}
                  label="Size"
                  fullWidth
                />
              </Grid>{" "}
              <Grid item xs={12} md={6}>
                <TextField
                  name="imageUrl"
                  value={v.imageUrl}
                  onChange={(e) => handleVariantChange(idx, e)}
                  label="Image URL"
                  fullWidth
                />
              </Grid>{" "}
              <Grid item xs={12} md={6}>
                <TextField
                  name="price"
                  type="number"
                  value={v.price}
                  onChange={(e) => handleVariantChange(idx, e)}
                  label="Price"
                  fullWidth
                  required
                />
              </Grid>{" "}
              <Grid item xs={12} md={6}>
                <TextField
                  name="stockQuantity"
                  type="number"
                  value={v.stockQuantity}
                  onChange={(e) => handleVariantChange(idx, e)}
                  label="Stock"
                  fullWidth
                  required
                />
              </Grid>{" "}
{user && user.roles[0].role === "ROLE_ADMIN" && 
  <>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="discount-label">Discount</InputLabel>
            <Select
              labelId="discount-label"
              name="discountId"
              value={v.discount?.discountId || ""}
              onChange={(e) => handleVariantChange(idx, e)}
              label="Discount">
              <MenuItem value="">
                <em>Select Discount</em>
              </MenuItem>
              {discounts.map((c) => (
                <MenuItem key={c.discountId} value={c.discountId}>
                  {c.percentage} - {c.amount}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  name="taxPercent"
                  type="number"
                  value={v.taxPercent}
                  onChange={(e) => handleVariantChange(idx, e)}
                  label="Tax Percentage"
                  fullWidth
                  required
                />
              </Grid>{" "}
 <Grid item xs={12} md={6}>
                <TextField
                  name="cgstPercent"
                  type="number"
                  value={v.cgstPercent}
                  onChange={(e) => handleVariantChange(idx, e)}
                  label="CGST Precent"
                  fullWidth
                  required
                />
              </Grid>{" "}
 <Grid item xs={12} md={6}>
                <TextField
                  name="sgstPercent"
                  type="number"
                  value={v.sgstPercent}
                  onChange={(e) => handleVariantChange(idx, e)}
                  label="SGST Percentage"
                  fullWidth
                  required
                />
              </Grid>{" "}
</>
}

              <Grid item xs={12} md={6}>
                {/* <TextField name="currencyId" value={v.currencyId} onChange={(e) => handleVariantChange(idx, e)} label="Currency ID" fullWidth /> */}

                <FormControl fullWidth>
                  <InputLabel id={`currency-label-${idx}`}>Currency</InputLabel>
                  <Select
                    labelId={`currency-label-${idx}`}
                    id={`currencyId-${idx}`}
                    name="currencyId"
                    value={v.currencyId || ""}
                    onChange={(e) => handleVariantChange(idx, e)}
                    required
                    label="Currency">
                    <MenuItem value="">
                      <em>Select Currency</em>
                    </MenuItem>
                    {/* Add a conditional check to avoid the 'Cannot read properties of undefined' error */}
                    {currencies &&
                      currencies.length > 0 &&
                      currencies.map((c) => (
                        <MenuItem key={c.currencyId} value={c.currencyId}>
                          {c.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <button type="button" onClick={() => removeVariant(idx)}
                style={{
    marginTop: "10px",
    padding: "10px 20px",
    backgroundColor: "#EE8078",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    transition: "background-color 0.3s ease"
  }}
                >
                  Remove
                </button>
              </Grid>{" "}
            </Grid>
          </div>
        ))}
      <Button type="button" onClick={addVariant}
      sx={{
    marginTop: "10px",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    transition: "background-color 0.3s ease",
         '&:hover': {
                    backgroundColor: '#49A39D',
                  },
  }}
      >
        Add Variant
      </Button>

      <br />
      <br />
      <Button type="submit" 
      sx={{
    marginTop: "10px",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    transition: "background-color 0.3s ease",
     '&:hover': {
                    backgroundColor: '#49A39D',
                  },
  }}
  >Submit Product</Button>
    </form>
  );
};

export default AddProduct;

